import React from 'react'
import { useUserStore } from '../stores/userStore'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'


export default function Options() {
    const welcomeMessage = useUserStore( state => state.welcomeMessage )
    const setWelcomeMessage = useUserStore( state => state.setWelcomeMessage )

    const userName = useUserStore( state => state.userName )
    const setUserName = useUserStore( state => state.setUserName )
    
    const cardCols = useUserStore( state => state.cardCols )
    const setCardCols = useUserStore( state => state.setCardCols )

    const editMode = useUserStore( state => state.editMode )

    const displayNote = useUserStore( state => state.displayNote )
    const toggleDisplayNote = useUserStore( state => state.toggleDisplayNote )

    const displayTodos = useUserStore( state => state.displayTodos )
    const toggleDisplayTodos = useUserStore( state => state.toggleDisplayTodos )

    const displayCards = useUserStore( state => state.displayCards )
    const toggleDisplayCards = useUserStore( state => state.toggleDisplayCards )

    const displayWeather = useUserStore( state => state.displayWeather )
    const toggleDisplayWeather = useUserStore( state => state.toggleDisplayWeather)

    const show = <FontAwesomeIcon icon="eye" />
    const hide = <FontAwesomeIcon icon="eye-slash" />

  return (
    <div className={`update-header ${editMode ? 'editing' : ''}`}>
        <label><input type="text" value={welcomeMessage} className="input" onChange={ e => setWelcomeMessage(e.target.value) } /></label>
        <label><input type="text" value={userName} className="input" onChange={ e => setUserName(e.target.value) } /></label>
        <label>
            <select className="input" value={cardCols} onChange={ e => setCardCols(e.target.value) }>
                <option value="1">1 Columns</option> 
                <option value="2">2 Columns</option> 
                <option value="3">3 Columns</option> 
                <option value="4">4 Columns</option> 
                <option value="5">5 Columns</option> 
                <option value="6">6 Columns</option> 
            </select>
        </label>
        <div><button className={`button-edit`} onClick={ () => { toggleDisplayNote() }}>{displayNote ? hide : show } Note</button></div>
        <div><button className={`button-edit`} onClick={ () => { toggleDisplayTodos() }}>{displayTodos ? hide : show} Todos</button></div>
        <div><button className={`button-edit`} onClick={ () => { toggleDisplayCards() }}>{displayCards ? hide : show} Cards</button></div>
        <div><button className={`button-edit`} onClick={ () => { toggleDisplayWeather() }}>{displayWeather ? hide : show} Weather</button></div>
    </div>
  )
}
